import React from 'react';
import update from 'immutability-helper';
import { Modal, Button, Row, Col, FormControl } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Comments from '../../../../../components/Comments/Comments';
import { validateFields } from '../../../../../shared/utils/handleBlowoutValidations';

class TapModalGeneric extends React.Component {
    state = {
        comment: '',
        errors: {},
        tapDate: '',
        tapDueDate: '',
        tapNumber: '',
    };

    componentWillUnmount() {
        this.setState(
            update(this.state, {
                errors: { $set: {} },
            })
        );
    }

    handleChange = e => {
        this.setState(
            update(this.state, {
                [e.target.name]: { $set: e.target.value },
            })
        );
        const errors = validateFields({
            [e.target.name]: e.target.value,
        });
        this.setState({ errors });
    };

    handleDateChange = name => momentDate => {
        this.setState(
            update(this.state, {
                [name]: { $set: momentDate },
            })
        );
        const errors = validateFields({
            [name]: momentDate,
        });
        this.setState({ errors });
    };

    handleConfirm = () => {
        const { comment, tapDueDate, tapDate, tapNumber } = this.state;

        const errors = validateFields({ tapDate, tapDueDate });
        this.setState({ errors });

        if (Object.keys(errors).length === 0) {
            const tap = {
                tapInfo: {
                    tapDueDate: tapDueDate.toISOString(),
                    tapDate: tapDate.toISOString(),
                    tapNumber: tapNumber,
                },
                comment: comment,
                hasTap: true,
            };

            this.props.handleTapCreate(tap);
            this.setState({ ...this.defaultState });
        }
    };

    handleClose = () => {
        this.setState({ ...this.defaultState });
        this.props.onClose();
    };

    render() {
        const { showModal } = this.props;
        const { comment, tapDueDate, tapDate, tapNumber, errors } = this.state;

        return (
            <Modal show={showModal} backdrop="static" onHide={this.handleClose}>
                <Modal.Header>
                    <Modal.Title>Tap</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row style={{ marginBottom: 20 }}>
                            <Col sm={5}>
                                <p>Tap date *</p>
                            </Col>
                            <Col sm={6}>
                                <Datetime
                                    className={errors.tapDate && 'datetime-error'}
                                    value={tapDate}
                                    onChange={this.handleDateChange('tapDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                />
                                {errors &&
                                    errors.tapDate && (
                                        <p
                                            style={{
                                                color: '#CF142B',
                                                marginTop: 5,
                                            }}
                                        >
                                            {errors.tapDate}
                                        </p>
                                    )}
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: 20 }}>
                            <Col sm={5}>
                                <p>Tap number</p>
                            </Col>
                            <Col sm={6}>
                                <FormControl
                                    style={
                                        errors.tapNumber && {
                                            borderColor: '#CF142B',
                                        }
                                    }
                                    type="text"
                                    maxLength="1000"
                                    name="tapNumber"
                                    value={tapNumber}
                                    onChange={this.handleChange}
                                />
                                {errors &&
                                    errors.tapNumber && (
                                        <p
                                            style={{
                                                color: '#CF142B',
                                                marginTop: 5,
                                            }}
                                        >
                                            {errors.tapNumber}
                                        </p>
                                    )}
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: 20 }}>
                            <Col sm={5}>
                                <p>Due date *</p>
                            </Col>
                            <Col sm={6}>
                                <Datetime
                                    className={errors.tapDueDate && 'datetime-error'}
                                    value={tapDueDate}
                                    onChange={this.handleDateChange('tapDueDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                />
                                {errors &&
                                    errors.tapDueDate && (
                                        <p
                                            style={{
                                                color: '#CF142B',
                                                marginTop: 5,
                                            }}
                                        >
                                            {errors.tapDueDate}
                                        </p>
                                    )}
                            </Col>
                        </Row>

                        <Row>
                            <div style={{ margin: 15 }}>
                                <Comments comment={comment} onCommentChange={this.handleChange} />
                            </div>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        onClick={this.handleConfirm}
                        disabled={!!errors.tapDueDate || !!errors.tapDate}
                    >
                        Create
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={this.handleClose}
                    >
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default TapModalGeneric;
